export class PaymentFailedError extends Error {
  constructor(message: string = 'Payment required') {
    super(message);
    this.name = 'PaymentFailedError';
  }
}
